<template>
	<div class="wrapper-area scroll-color" v-scroll-paginate="scrollHandler">
		<div v-if="actionsList.length" class="wrapper-list">
			<div v-for="action in actionsList" :key="`${action.id} - ${action.check}`" class="item">
				<actions-wrapper
					:action="action"
					:checked="action.check"
					v-model="action.check"
					@input="() => cleanChecks(action.id)"
				/>
			</div>
		</div>

		<div v-show="loading" class="loading-area">
			<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
		</div>
	</div>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'
	import ActionsWrapper from './components/action-wrapper/index.vue'

	import { scrollPaginate } from '@/directives'

	export default {
		name: 'action-wrapper-list',

		components: { ActionsWrapper, uiLoadIndicator },

		directives: { scrollPaginate },

		props: {
			value: {
				type: Array,
				default: () => [],
			},

			loading: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			return {
				actionsList: [],
			}
		},

		mounted() {
			this.actionsList = this.value
		},

		methods: {
			scrollHandler() {
				this.$emit('scroll')
			},

			cleanChecks(id) {
				this.actionsList = this.actionsList.map((action) => {
					if (action.id !== id) action.check = false
					return action
				})
			},
		},

		watch: {
			value: {
				deep: true,
				handler(value) {
					this.actionsList = value
				},
			},

			actionsList: {
				deep: true,
				handler(value) {
					this.$emit('input', value)
				},
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
